import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
// import { Box } from '@cp/ds/src/components/box';
import { StyledButton } from '@cp/ds/src/components/styled/styledButton';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import capitalize from 'lodash/capitalize';
import React from 'react';
// import Hatches from '@cp/ds/src/assets/shapes/hatchesRounded.svg';
import { cx } from '@emotion/css';
import { AnnounceHintWrapper } from '@cp/ds/src/components/announceHintWrapper';
import { careerIdToLayoutData } from '@cp/entities/career';
import { CAREER_ID_TO_CAREER_NAME, EButtonName } from 'src/shared/tracking';
import { StatsLabel } from './components/statsLabel';
import { CareerTileProps } from './model';

export const CareerButton: React.FC<CareerTileProps> = ({ careerId, label, sx, onClick, catalogStats, disabled }) => {
  const theme = useTheme();
  const dictItem = careerIdToLayoutData[careerId];

  if (!dictItem) {
    return null;
  }

  const Icon = dictItem.iconComponent;

  return (
    <AnnounceHintWrapper>
      {({ setAnnounceMessageVisible }) => (
        <StyledButton
          className={cx(EButtonName.SelectCareer, CAREER_ID_TO_CAREER_NAME[careerId])}
          disabled={disabled}
          onClick={disabled ? undefined : onClick ?? (() => setAnnounceMessageVisible(true))}
          sx={{
            width: '100%',
            display: 'flex',
            background: theme.palette.white,
            alignItems: 'center',
            flexDirection: 'column',
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            p: { xs: theme.spacing(2.5, 1, 2), md: theme.spacing(3.25, 1, 2.75), xxl: theme.spacing(5, 1, 4.5) },
            borderRadius: `${theme.borderRadius.large}px`,
            transition: theme.transitions.create(['background-color', 'transform', 'box-shadow'], {
              duration: theme.transitions.duration.short,
            }),
            boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15)',
            '@media (pointer: fine)': {
              '&:hover': {
                backgroundColor: theme.palette['gray ultra light'],
                transform: 'scale(1.04)',
                boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25), 0px 0px 20px rgba(0, 0, 0, 0.15)',
              },
            },
            ...sx,
          }}
        >
          {/* <Box sx={{ position: 'relative' }}> */}
          <Icon
            sx={{
              fontSize: { xs: '3.25rem', [MOBILE_BREAKPOINT_THRESHOLD]: '3.75rem' },
              position: 'relative',
              zIndex: 1,
              color: disabled ? theme.palette['gray light'] : undefined,
            }}
          />
          {/* <Hatches style={{ position: 'absolute', bottom: 0, right: 0, width: { xs: 41, [MOBILE_BREAKPOINT_THRESHOLD]: 49 } }} /> */}
          {/* </Box> */}

          <Typography
            sx={{
              // mt: { xs: 1, [MOBILE_BREAKPOINT_THRESHOLD]: 0.5 },
              mt: 0.5,
              typography: { xs: 'caption bold', [MOBILE_BREAKPOINT_THRESHOLD]: 'button' },
            }}
          >
            {capitalize(label)}
          </Typography>

          {catalogStats && <StatsLabel {...catalogStats} careerId={careerId} />}
        </StyledButton>
      )}
    </AnnounceHintWrapper>
  );
};
